<template>
  <vue-good-table
    :columns="columns"
    :rows="coordinators"
    :line-numbers="true"
  >
    <div slot="emptystate" class="text-muted text-center">
      ไม่มีข้อมูล
    </div>

    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'delete'">
        <b-button variant="danger" block size="sm" @click="deletePerson(props.row.user.username)">
          <font-awesome-icon icon="trash" />ลบ
        </b-button>
      </span>
    </template>
  </vue-good-table>
</template>

<script>
import gql from 'graphql-tag'
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    coordinators: Array,
    // eslint-disable-next-line vue/require-default-prop
    group: String,
    // eslint-disable-next-line vue/require-default-prop
    yearId: String
  },
  data () {
    return {
      columns: [
        {
          label: 'Username',
          field: 'user.username',
          width: '130px'
        },
        {
          label: 'ชื่อ-นามสกุล',
          field: 'user.thFullName'
        },
        {
          label: 'การกระทำ',
          field: 'delete',
          width: '100px'
        }
      ]
    }
  },
  methods: {
    async delete (username) {
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $username: String!, $acYearId: ID) { groupRemoveCoordinator(id: $id, username: $username, acYearId: $acYearId) { id } }`,
        variables: { id: this.group, username: username, acYearId: this.yearId }
      }).then(() => {
        this.$bvToast.toast('ลบผู้ประสานงานสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })
      })
        .catch(() => {
          this.$bvToast.toast('เกิดข้อผิดพลาดในการลบผู้ประสานงาน', {
            title: 'แจ้งเตือน',
            variant: 'danger',
            solid: true,
            noCloseButton: true
          })
        })
      this.$emit('finish')
    },
    deletePerson (username) {
      // Use sweetalert2
      this.$swal.fire({
        title: 'ยืนยันการลบผู้ประสานงาน',
        text: 'คุณต้องการลบผู้ประสานงานรายนี้หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.delete(username)
        } else if (
        // Read more about handling dismissals
          result.dismiss === this.$swal.DismissReason.cancel
        ) {
          //
        }
      })
    }
  }
}
</script>

<style>

</style>
